import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstCfd: [],
		cfd: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch, getters }, cfdevento) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/Events/Find/${cfdevento}`)
				.then(response => {
					let cfd = Utils.ValidateAxiosResponse(response.data)
					commit("setCfd", cfd)
					if(getters.getCfd != null)
						commit("setUpload", true)
					return cfd
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return null
				})
			commit("setLoading", false)
			return payload
		},
		save({ dispatch, getters }) {
			if (getters.getUpdate) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ dispatch, commit, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Salvando",
					indeterminate: true
				},
				{ root: true }
			)
			let cfd = {...getters.getCfdForSave}
			let payload = await this._vm.$axios
				.post("/Customer/Events/Insert", cfd)
				.then(async response => {
					let cfdevento = Utils.ValidateAxiosResponse(response.data)
					await dispatch("saveImages", cfdevento)
					commit("setCfd", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch, commit, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Salvando",
					indeterminate: true
				},
				{ root: true }
			)
			let cfd = {...getters.getCfdForSave}
			let payload = await this._vm.$axios
				.put("/Customer/Events/Update", cfd)
				.then(async response => {
					Utils.ValidateAxiosResponse(response.data)
					await dispatch("saveImages", cfd.cfdevento)
					commit("setCfd", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Excluindo",
					indeterminate: true
				},
				{ root: true }
			)
			let payload = await this._vm.$axios
				.delete(`/Customer/Events/Delete/${getters.getCfd.cfdevento}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async saveImages({ dispatch, getters }, cfdevento) {
			if (cfdevento == null) return
			let cfd = getters.getCfd

			if(cfd.cfddoc1 && typeof cfd.cfddoc1 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc1, field: "cfddoc1", cfdevento })
			if(cfd.cfddoc2 && typeof cfd.cfddoc2 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc2, field: "cfddoc2", cfdevento })
			if(cfd.cfddoc3 && typeof cfd.cfddoc3 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc3, field: "cfddoc3", cfdevento })
			if(cfd.cfddoc4 && typeof cfd.cfddoc4 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc4, field: "cfddoc4", cfdevento })
			if(cfd.cfddoc5 && typeof cfd.cfddoc5 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc5, field: "cfddoc5", cfdevento })
			if(cfd.cfddoc6 && typeof cfd.cfddoc6 !== "string")
				await dispatch("saveImage", { image: cfd.cfddoc6, field: "cfddoc6", cfdevento })
		},
		saveImage({ dispatch }, { image, field, cfdevento }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Salvando",
					indeterminate: true
				},
				{ root: true }
			)
			let formData = new FormData()
			formData.append("image", image)
			let payload = this._vm.$axios
				.put(`/Customer/Events/SaveDocument/${cfdevento}/${field}`, formData)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		deleteImage({ dispatch }, { field, cfdevento }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Excluindo",
					indeterminate: true
				},
				{ root: true }
			)
			let payload = this._vm.$axios
				.put(`/Customer/Events/DeleteDocument/${cfdevento}/${field}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Customer/Events/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setCfd", null)
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			commit("setLoading", false)
		},
		setSearch({ commit }, search) {
			commit("setSearch", search)
		},
		setLoading({ commit }, loading) {
			commit("setLoading", loading)
		},
		setInsert({ commit }, insert) {
			commit("setInsert", insert)
		},
		setCfddoc({ commit }, { field, image }) {
			commit("setCfddoc", { field, image })
		}
	},
	getters: {
		getCfd: state => {
			return state.cfd
		},
		getLstCfd: state => {
			return state.lstCfd
		},
		getInsert: state => {
			return state.insert
		},
		getUpdate: state => {
			return state.update
		},
		getLoading: state => {
			return state.loading
		},
		getItemsPerPage: state => {
			return state.itemsPerPage
		},
		getSearch: state => {
			return state.search
		},
		getHasNext: state => {
			return state.hasNext
		},
		getCfdForSave: state => {
			let cfd = {...state.cfd}
			cfd.cfdabert = Utils.ParseToDate(cfd.cfdabert)
			if(typeof cfd.cfddoc1 !== "string")
				cfd.cfddoc1 = null
			if(typeof cfd.cfddoc2 !== "string")
				cfd.cfddoc2 = null
			if(typeof cfd.cfddoc3 !== "string")
				cfd.cfddoc3 = null
			if(typeof cfd.cfddoc4 !== "string")
				cfd.cfddoc4 = null
			if(typeof cfd.cfddoc5 !== "string")
				cfd.cfddoc5 = null
			if(typeof cfd.cfddoc6 !== "string")
				cfd.cfddoc6 = null
			return cfd
		}
	},
	mutations: {
		initForm(state) {
			state.insert = false
			state.update = false
			state.cfd = null
		},
		setSearch(state, search) {
			state.search = search
		},
		setUpload(state, upload) {
			state.update = upload
		},
		setCfd(state, cfd) {
			if(cfd?.cfdabert && cfd.cfdabert != null){
				cfd.cfdabert = new Date(cfd.cfdabert).toLocaleDateString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
			state.cfd = cfd
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setInsert(state, insert) {
			state.insert = insert
		},
		setParamsDataTable(state, payload) {
			state.lstCfd = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setCfddoc(state, { field, image }) {
			state.cfd[field] = image
		}
	}
}
